var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonTitle from "~/components/common/common-title.vue";
import { HomePageService } from '~/services/domain-service/home-page.service';
import { Dependencies } from "~/core/decorator";
var RankDataBox = /** @class */ (function (_super) {
    __extends(RankDataBox, _super);
    function RankDataBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.radio = 'year';
        _this.value = '';
        _this.dateType = 'year';
        _this.format = 'yyyy';
        _this.placeholder = '请选择年份';
        _this.startDate = '';
        _this.endDate = '';
        return _this;
    }
    RankDataBox.prototype.refreshData = function () {
        var _this = this;
        this.homePageService.getCollectionRanking({
            type: this.menuType,
            startDate: this.startDate,
            endDate: this.endDate
        }).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    RankDataBox.prototype.mounted = function () {
        this.dateChange(new Date());
        this.refreshData();
    };
    RankDataBox.prototype.paramsHandler = function () {
        var params = {
            type: this.menuType,
            startDate: this.startDate,
            endDate: this.endDate
        };
    };
    RankDataBox.prototype.dateChange = function (val) {
        this.value = val;
        var date = new Date(val);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var lastDay = new Date(year, month, 0).getDate();
        switch (this.radio) {
            case 'year':
                this.startDate = year + "-01-01 00:00:00";
                this.endDate = year + "-12-31 23:59:59";
                break;
            case 'month':
                this.startDate = this.$filter.dateFormat(val) + " 00:00:00";
                this.endDate = year + "-" + month + "-" + lastDay + " 23:59:59";
                break;
            case 'week':
                this.weekHandler(year, month, day, lastDay);
                break;
            case 'day':
                this.startDate = this.$filter.dateFormat(val) + " 00:00:00";
                this.endDate = this.$filter.dateFormat(val) + " 23:59:59";
                break;
            default:
                this.startDate = '';
                this.endDate = '';
                break;
        }
        this.refreshData();
    };
    RankDataBox.prototype.radioChange = function (val) {
        switch (val) {
            case 'year':
                this.dateType = "year";
                this.format = 'yyyy';
                this.placeholder = '请选择年份';
                break;
            case 'month':
                this.dateType = "month";
                this.format = 'yyyy-MM';
                this.placeholder = '请选择月份';
                break;
            case 'week':
                this.dateType = "week";
                this.format = 'yyyy 第 WW 周';
                this.placeholder = '请选择周';
                break;
            case 'day':
                this.dateType = "date";
                this.format = 'yyyy-MM-dd';
                this.placeholder = '请选择日期';
                break;
        }
        this.value = '';
    };
    RankDataBox.prototype.weekHandler = function (year, month, day, lastDay) {
        this.getfirstDate(year, month, day);
        this.getEndDate(year, month, day, lastDay);
    };
    RankDataBox.prototype.getEndDate = function (year, month, day, lastDay) {
        var end = day + 5;
        var endMonth = '';
        var endYear = '';
        if (month >= 12 && end > lastDay) {
            endYear = year + 1;
            endMonth = 1;
            end = '0' + (end - lastDay);
        }
        else if (month < 12 && end > lastDay) {
            endYear = year;
            endMonth = month + 1;
            end = '0' + (end - lastDay);
        }
        else {
            endYear = year;
            endMonth = month;
            end = end < 10 ? '0' + end : end;
        }
        this.endDate = endYear + "-" + endMonth + "-" + end + " 23:59:59";
    };
    RankDataBox.prototype.getfirstDate = function (year, month, day) {
        var first = day - 1;
        var firstYear = '';
        var firstMonth = '';
        if (month === 1 && day === 1) {
            firstYear = year - 1;
            firstMonth = 12;
            first = new Date(year, month, 0);
        }
        else if (month !== 1 && day === 1) {
            firstYear = year;
            firstMonth = month - 1;
            first = new Date(year, month, 0);
        }
        else {
            firstYear = year;
            firstMonth = month;
            first = first < 10 ? '0' + first : first;
        }
        this.startDate = firstYear + "-" + firstMonth + "-" + first + " 00:00:00";
    };
    __decorate([
        Dependencies(HomePageService)
    ], RankDataBox.prototype, "homePageService", void 0);
    __decorate([
        Prop()
    ], RankDataBox.prototype, "menuType", void 0);
    RankDataBox = __decorate([
        Component({
            components: {
                CommonTitle: CommonTitle
            }
        })
    ], RankDataBox);
    return RankDataBox;
}(Vue));
export default RankDataBox;
